module.exports = __webpack_public_path__ + "img/pagarme.dcdb54ef.png";